import utils from "@/utils/index.js";
export default {
    ADDLIST(state, {lists}) {
    	lists.forEach((item) => {
            if(item.images.length >= 3) {
                item.typesetting = 3;
            } else {
                item.typesetting = utils.loadRandomProbability();
            }
    		state.channleList.push(item);
    	});
    },
    CLEARCHANNELLIST(state) {
        state.channleList = [];
    }
};


// WEBPACK FOOTER //
// ./src/vuex/channel/mutations.js